// extracted by mini-css-extract-plugin
export default {"wrapper":"SubVerticalLinks_wrapper__pS+C1"};